import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export const useOrganizationId = () => {
  return useQuery({
    queryKey: ['organization-id'],
    queryFn: async () => {
      const { data: { session } } = await supabase.auth.getSession();
      if (!session?.user) throw new Error('No authenticated user');

      const organizationId = session.user.app_metadata?.active_organization_id;
      if (!organizationId) {
        throw new Error('No active organization selected');
      }

      return organizationId;
    },
  });
};